// Hand-off mode: the app locks to the My Card QR screens so the phone can be
// passed around at a meetup. The flag lives in localStorage so a reload (or a
// hard swipe-kill and reopen) comes back still locked; only a PIN or Face ID
// unlock clears it. The user id is stored alongside because the unlock has to
// work even after the session cookie expires — both auth endpoints mint a
// fresh session from scratch.

const KEY = "bt_handoff";
const USER_KEY = "bt_handoff_user";
const listeners = new Set();

export function isHandoff() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function handoffUserId() {
  try {
    return localStorage.getItem(USER_KEY) || "";
  } catch {
    return "";
  }
}

export function startHandoff(userId) {
  try {
    localStorage.setItem(KEY, "1");
    localStorage.setItem(USER_KEY, userId || "");
  } catch {
    /* private mode — the in-memory lock still engages for this page life */
  }
  listeners.forEach((fn) => fn());
}

export function endHandoff() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(USER_KEY);
  } catch {
    /* ignore */
  }
  listeners.forEach((fn) => fn());
}

export function subscribeHandoff(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
